/**
 * The console's official guides for this person (GET /api/me/guides, the
 * decided-free `me` lane): { version, guides }, already filtered by the worker
 * to what the person may use. Called through its shared contract only.
 */
import { callContract } from '../contractClient'
import { contracts } from '../../../../shared/features/me.contracts'

export const getGuides = () => callContract(contracts.getGuides)
